import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import { medicalHistoryForm } from "../fieldData";
import { Button, CircularProgress, debounce } from "@mui/material";
import {
  ChangeEvent,
  FC,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { MedicalHistoryContext, contextType } from "../MedicalHistory";
import { AddMedicalHistory, getDisease } from "../../../../services";
import { useMutation } from "react-query";
import {
  AddMedicalHistoryFormType,
  initialMedicalHistoryData,
  MedicalFormType,
} from "../types";
import { useParams } from "react-router-dom";
import usePopup from "../../../../../hooks/usePopup";
import { useForm } from "react-hook-form";
import { clinicId } from "../../../../../constants";
import useAuthentication from "@hooks/useAuthentication";
import { EmrContext } from "../../../../index";
const MedicalHistoryForm: FC<{ close?: () => void }> = ({ close }) => {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const { edit, setRefetch, setEdit } = useContext(
    MedicalHistoryContext
  ) as contextType;
  const { triggerConsultationStart } = useContext(EmrContext);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: initialMedicalHistoryData,
  });
  const [searchValue, setSearchValue] = useState<string>("");

  const { mutate: saveMedicalHistory, isLoading: saveMedicalHistoryLoading } =
    useMutation(AddMedicalHistory, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            duration: 2000,
            variant: "success",
          });
          triggerConsultationStart();
          setRefetch(true);
          searchDisease("");
          setEdit(null);
          reset();
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            duration: 2000,
            variant: "warning",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          duration: 2000,
          variant: "warning",
        });
      },
    });

  const {
    mutate: searchDisease,
    data: diseaseList,
    isLoading: searchLoading,
  } = useMutation(getDisease);

  const diseases = useMemo(() => {
    if (diseaseList?.response.length == 0) {
      return [
        {
          icdId: null,
          icdCode: null,
          icdName: searchValue,
        },
      ];
    } else {
      return diseaseList?.response;
    }
  }, [diseaseList?.response]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    searchDisease(value);
  };

  const debounceSearch = debounce(handleSearch, 500);

  const onsubmit = (value: any) => {
    const formData: MedicalFormType = {
      ...value,
    };
    let data: AddMedicalHistoryFormType = {
      duration: formData.duration,
      medication: formData.medication,
      emrDisease: {
        diseaseClinicId: clinicId,
        diseaseCreatedByDate: null,
        diseaseCode: formData.diseaseDetails?.icdCode as string,
        diseaseCreatedById: Number(user?.userId),
        diseaseName: formData.diseaseDetails?.icdName as string,
        diseaseStatus: 1,
        diseaseId: formData.diseaseDetails?.icdId as number,
      },
      encounter: parseInt(encounterId as string),
      id: 0,
      status: 1,
    };
    if (Boolean(edit)) {
      data = {
        ...edit,
        ...data,
        id: edit?.id as number,
      };
      saveMedicalHistory(data);
    } else {
      saveMedicalHistory(data);
    }
  };

  useEffect(() => {
    searchDisease("");
    if (Boolean(edit)) {
      const data = {
        duration: edit?.duration as string,
        medication: edit?.medication as string,
        diseaseDetails: {
          icdId: edit?.emrDisease.diseaseId as number,
          icdCode: edit?.emrDisease.diseaseCode as string,
          icdName: edit?.emrDisease.diseaseName as string,
        },
      };
      reset(data);
    } else {
      reset(initialMedicalHistoryData);
    }
  }, [edit]);

  return (
    <div className="gap-5 m-2">
      <form onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-6 gap-2 ">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={diseases || []}
              {...medicalHistoryForm.Diseases}
              loading={searchLoading}
              fieldProps={{
                ...medicalHistoryForm.Diseases.fieldProps,
                onChange: debounceSearch,
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...medicalHistoryForm.Duration}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...medicalHistoryForm.Medication}
            />
          </div>
          <div className="col-span-full flex flex-row items-center justify-end gap-2">
            <Button
              type="submit"
              color="success"
              disabled={saveMedicalHistoryLoading}
              endIcon={
                saveMedicalHistoryLoading && <CircularProgress size={18} />
              }
            >
              Save
            </Button>
            <Button
              color="error"
              onClick={() => {
                close && close();
              }}
            >
              {" "}
              cancel{" "}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MedicalHistoryForm;
